import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JbDividerModule, JbLinkModule } from 'jb-component-library';

import { LinksModule } from '../../../shared/ui/links';
import { JbListComponent } from './jb-list.component';
import { JbListItemComponent } from './jb-list-item/jb-list-item.component';
import { JbListItemsGroupComponent } from './jb-list-items-group/jb-list-items-group.component';

@NgModule({
  imports: [CommonModule, JbDividerModule, JbLinkModule, LinksModule],
  declarations: [
    JbListComponent,
    JbListItemsGroupComponent,
    JbListItemComponent,
  ],
  exports: [JbListComponent, JbListItemsGroupComponent, JbListItemComponent],
})
export class JbListModule {}
